import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../../store';

export type ThemeMode = 'light' | 'dark';

interface SettingsState {
  mode: ThemeMode;
}

const initialState: SettingsState = {
  mode: 'light',
};

const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    setMode(state, action: PayloadAction<ThemeMode>) {
      state.mode = action.payload;
    },
    toggleMode(state) {
      state.mode = state.mode === 'light' ? 'dark' : 'light';
    },
  },
});
export const selectMode = (state: RootState) => state.settings.mode;

export const { setMode, toggleMode } = settingsSlice.actions;
export default settingsSlice.reducer;
